import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import {
  GET_ACCOUNTS,
  SET_ACCOUNTS_PAGINATION,
  SET_ACCOUNTS_FILTERS,
  RESET_ACCOUNTS,
  TOGGLE_ACCOUNT,
} from 'accounts/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const account = new schema.Entity('accounts');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name', 'description'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { accounts: {} },
  result: { accounts: [] },
};

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });

export const getFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  },
  ...normalize({ accounts: payload.records }, { accounts: [account] }),
});

export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    accounts: {
      ...state.entities.accounts,
      [meta.id]: { ...state.entities.accounts[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    accounts: {
      ...state.entities.accounts,
      [meta.id]: { ...state.entities.accounts[meta.id], isLoading: false },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    accounts: {
      ...state.entities.accounts,
      [payload.account.id]: { ...payload.account, isLoading: false },
    },
  },
});

const reducers = {
  [GET_ACCOUNTS]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_ACCOUNTS_PAGINATION]: setPagination,
  [SET_ACCOUNTS_FILTERS]: setFilters,
  [RESET_ACCOUNTS]: reset,
  [TOGGLE_ACCOUNT]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/reducers/accounts_list_reducers.js